import TransportBadgeTrigger from '@/components/manage/tickets/badge/TransportBadgeTrigger';
import StopDetails from '@/components/purchase/journey/StopDetails';
import { TransText } from '@/i18n/trans/text';
import type { LegDTO } from '@/types/dto/agent';
import { breakpoints } from '@/utils/breakpoints';
import { Button, Icons, Popover, Sheet } from '@fleet/webshop-ui';
import type { FC } from 'react';
import { useMediaQuery } from 'react-responsive';

interface TransportBadgeDetailedProps {
  leg: LegDTO;
  refundedLike: boolean;
}

const TransportBadgeDetailed: FC<TransportBadgeDetailedProps> = ({
  leg,
  refundedLike,
}) => {
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });

  const renderTrigger = () => (
    <Button
      variant="ghost"
      data-testid="transport-badge-trigger"
      className="group h-auto p-0"
    >
      <TransportBadgeTrigger leg={leg} refundedLike={refundedLike} isDetailed />
    </Button>
  );

  const renderContent = () => {
    return <StopDetails leg={leg} reverse />;
  };

  if (isLaptopOrBigger) {
    return (
      <Popover
        trigger={renderTrigger()}
        content={renderContent()}
        data-testid="transport-badge-popover"
        className={{ content: 'w-[360px] p-4 text-dark' }}
      />
    );
  }

  return (
    <Sheet
      trigger={renderTrigger()}
      side="bottom"
      headerIcon={
        <Icons.nonStop width={20} height={20} className="text-primary" />
      }
      headerTitle={<TransText i18nKey="route" />}
      className={{ content: 'p-0' }}
      data-testid="transport-badge-sheet"
    >
      <div className="p-4 pt-0">{renderContent()}</div>
    </Sheet>
  );
};

export default TransportBadgeDetailed;
